var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLocation = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 124,
    viewBox: "0 0 81 124",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BB2025",
    fillRule: "evenodd",
    d: "M81 40.435C81 62.776 40.5 124 40.5 124S0 62.776 0 40.435C0 18.104 18.128 0 40.5 0 62.867 0 81 18.104 81 40.435zM56 40c0-8.832-7.168-16-16-16-8.837 0-16 7.168-16 16 0 8.837 7.163 16 16 16 8.832 0 16-7.163 16-16z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLocation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/location.15de69db.svg";
export { ForwardRef as ReactComponent };